import React, { useEffect, useState } from 'react';

import { FilterDeviceListInterface } from '../../../interface/schedule-management.interface';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { fetchAllStationsList } from '../../../redux/slice/ApprovedStationManagementSlice';
import {
  fetchAllDevicesList,
  fetchOneDevicePoints,
} from '../../../redux/slice/DeviceManagementSlice';
import MyButton from '../../../shared-components/button/Button';
import SelectFiled from '../../../shared-components/select-field/SelectField';

interface AddRoleInterface {
  closeModal: () => void;
}
/**
 * Role Add page function component
 */
function DeviceFilter({ closeModal }: AddRoleInterface) {
  const dispatch = useAppDispatch();
  const { allStations, loading } = useAppSelector((state) => state.approvedStation);
  const { allDevices } = useAppSelector((state) => state.device);
  const [filterDetails, setFilterDetails] = useState<FilterDeviceListInterface>({
    station: '',
    device: '',
  });

  /**
   * Get data function
   */
  const fetchData = () => {
    if (!loading) {
      dispatch(fetchAllStationsList());
    }
  };

  /**
   * Handle the input change function
   * @param name
   * @param value
   */
  const handleInputChange = (name: string, value: string | number) => {
    setFilterDetails((previous) => ({
      ...previous,
      [name]: value,
    }));
    if (name === 'station') {
      dispatch(fetchAllDevicesList({ id: value }));
    }
  };

  /**
   * Handle the submit function
   */
  const handleSubmit = () => {
    dispatch(fetchOneDevicePoints({ id: filterDetails.device }));
    closeModal();
  };

  useEffect(() => {
    if (allStations.length === 0) {
      fetchData();
    }
  }, []);

  return (
    <div className="filter-user-warp">
      <div className="form-body">
        <div className="form-field">
          <SelectFiled
            name="station"
            inputLabel="Station Name / Id"
            onChangeValue={handleInputChange}
            placeholder="Select Station"
            options={allStations}
            selectedValue={filterDetails.station}
          />
        </div>
        <div className="form-field">
          <SelectFiled
            name="device"
            inputLabel="Device"
            placeholder="Select Device"
            onChangeValue={handleInputChange}
            options={allDevices}
            selectedValue={filterDetails.device}
          />
        </div>
        <div className="form-field table-bottom-button-list form-bottom-button end">
          <div className="table-button-item">
            <MyButton label="Cancel" buttonType="back" onClickFunc={closeModal} />
          </div>
          <div className="table-button-item">
            <MyButton label="Apply" buttonType="submit" onClickFunc={handleSubmit} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeviceFilter;
